class AnsatteFilter {
  constructor() {
    this.dropdown = document.querySelector('#ansattDropdown');
    this.ansatte = document.querySelectorAll('.ansattCard');
    this.events();
  }

  events() {
    if (this.dropdown) {
      this.dropdown.addEventListener('change', ev => {
        this.hideUnrelated(ev.target.value);
      });
    }
  }

  hideUnrelated(currentAvdeling) {
    this.ansatte.forEach(ansatt => {
      let ansattAvdelinger = ansatt.querySelector('.avdeling').querySelectorAll('span');
      ansattAvdelinger = Array.from(ansattAvdelinger).map(function(x) {return x.innerHTML.toUpperCase() });
      if (this.dropdown.selectedIndex === 0) {
        ansatt.classList.remove('ansattCard--hide');
      } else if (ansattAvdelinger.includes(currentAvdeling.toUpperCase())) {
        ansatt.classList.remove('ansattCard--hide');
      } else {
        ansatt.classList.add('ansattCard--hide');
      }
    });
  }

  }

export default AnsatteFilter;